import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
  useMsalAuthentication,
} from "@azure/msal-react";
import { loginRequest } from "./components/auth/authConfig";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./AppRoutes";

const App = () => {
  const { accounts, instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);

  // Hook que maneja automáticamente login interactivo si no hay sesión
  useMsalAuthentication("redirect", loginRequest);

  useEffect(() => {
    //console.log("Cuentas en contexto MSAL:", accounts);
    if (accounts.length > 0) {
      // Intentar obtener token silencioso
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          //console.log("AccessToken:", response.accessToken);
          setAccessToken(response.accessToken);

        })
        .catch((err) => {
          console.warn("Silent token falló, fallback a redirect", err);
          instance.acquireTokenRedirect(loginRequest);
        });
    }
  }, [accounts, instance]);

  return (
    <AuthProvider>
      <Router>
        <AuthenticatedTemplate>
            <AppRoutes />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <div>Redirigiendo a Entra ID para iniciar sesión...</div>
        </UnauthenticatedTemplate>
      </Router>
    </AuthProvider>
  );
};

export default App;

